const loding = false


export default {
    loding,
}